import React from 'react'
import Header from '../../components/Header'
import Hero from './Hero'
import HeroBox from './HeroBox'
import Brands from './Brands'
import TImeline from './TImeline'
import WhyWeDoIt from './WhyWeDoIt'
import Status from './Status'
import TuberPartners from './TuberPartners'
import MeetMembers from './MeetMembers'
import Form from './Form'
import SocialMediaPosts from './SocialMediaPosts'
import FAQSection from './FAQSection'
import ContactSection from './ContactSection'
import Footer from '../../components/Footer'


const Home = () => {
    return (
        <main>
            <Header />
            <Hero />
            <HeroBox />
            <Brands />
            <TImeline />
            <WhyWeDoIt />
            <Status />
            <TuberPartners />
            <MeetMembers />
            <Form />
            <SocialMediaPosts />
            <FAQSection />
            <ContactSection />
            <Footer />
        </main>
    )
}

export default Home